__turbopack_context__.v({
  "className": "poppins_79cc0093-module__tgCcCW__className",
});
